import { drinksLeft, drinksRight} from "./images"
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react"

import { FooterComponents } from './FooterComponents';
import LoginModal from '../oauth/LoginModal';
import Header from "../LandingPage/Header"; 


export default function AboutPage() {

    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);


    // Handle mobile menu scroll lock
    useEffect(() => {
        // Add the "no-scroll" class when the mobile menu is open
        if (isMobileMenuOpen) {
            document.body.classList.add("no-scroll");
        } else {
            document.body.classList.remove("no-scroll");
        }

        // Cleanup when the component unmounts or when isMobileMenuOpen changes
        return () => {
            document.body.classList.remove("no-scroll");
        };
    }, [isMobileMenuOpen]);

    return (
        <div className="overflow-hidden md:overflow-visible relative min-h-screen bg-white px-0 md:overflow-hidden">

            <Header setIsLoginOpen={setIsLoginOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} isMobileMenuOpen={isMobileMenuOpen}/>


            {/* Left Side Drinks */}
            <div
                className="fixed left-0 top-24 bottom-0 md:w-24 lg:w-32 hidden md:block -ml-5"
                style={{
                    backgroundImage: `url(${drinksLeft || "/placeholder.svg"})`,
                    backgroundRepeat: 'repeat-y',
                    backgroundSize: 'contain'
                }}
            ></div>

            {/* Right Side Drinks */}
            <div
                className="fixed right-0 top-16 bottom-0 md:w-24 lg:w-32 hidden md:block -mr-5"
                style={{
                    backgroundImage: `url(${drinksRight || "/placeholder.svg"})`,
                    backgroundRepeat: 'repeat-y',
                    backgroundSize: 'contain'
                }}
            ></div>


            {/* <div className="hidden md:block absolute font-semibold hover:opacity-80 text-[#2b0062] text-xl top-6 right-4 flex space-x-6 overflow-hidden">
                <Link to="/faq" className=" font-semibold hover:opacity-80" onClick={() => window.scrollTo(0, 0)}>FAQ</Link>
                <a
                    href="https://calendly.com/emmarosefisher1/30min"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-semibold hover:opacity-80"
                >
                    Get a Demo
                </a>
                <a
                    href="https://tally.so/r/wM8JYk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80"
                >
                    Refer a Venue
                </a>
                <button onClick={() => setIsLoginOpen(true)} className="hover:opacity-80">
                    Log In
                </button>
            </div> */}


            {/* Main content for mobile screens*/}
            <div className="mx-10 pb-6 md:hidden max-w-3xl mx-auto flex flex-col items-center justify-center min-h-screen text-center z-50">

                <h1 className="text-5xl mt-6 font-bold text-center mb-8 text-[#2b0062]">About Us</h1>
                <div className="space-y-8 text-center">
                    <p className="text-2xl font-semibold text-[#2b0062]">
                        LastCall was created by service industry professionals for service industry professionals.
                    </p>

                    <p className="text-lg text-gray-800">
                        It's insane that in 2025 you need multiple tools to promote a night out—social media, email, flyers—it's all
                        too much. Relying on word-of-mouth just doesn't cut it when trying to fill your bar.
                    </p>

                    <p className="text-lg text-gray-800">
                        With a simple, easy-to-use interface and zero heavy lifting on your part, LastCall handles the marketing
                        while you focus on what you do best: serving great drinks.
                    </p>

                    <p className="text-2xl font-semibold text-[#2b0062]">
                        Our mission? To help you pack the bar and boost your sales.
                    </p>

                    <p className="text-lg text-gray-800">
                        Getting the word out and keeping your crowd engaged shouldn't be complicated. We're here to make it easier
                        for bars to connect with their patrons, drive foot traffic, and turn every night into a win. At LastCall, a
                        win means more money.
                    </p>

                    <p className="text-2xl font-semibold text-[#2b0062]">That is worth celebrating.</p>
                </div>
                {/* Mobile Footer */}
                <div className="md:hidden mt-16">
                    <FooterComponents isMobile={true} setIsLoginOpen={setIsLoginOpen} />
                </div>
            </div>

            {/* Main content */}
            <div className="md:max-w-3xl xl:max-w-5xl mx-auto hidden md:flex flex-col items-center justify-start md:mt-20 min-h-screen text-center z-50">
                <h1 className="text-5xl md:text-5xl font-bold text-center mb-12 text-[#2b0062]">About Us</h1>
                <div className="space-y-8 text-center mb-20">
                    <p className="text-2xl md:text-3xl font-semibold text-[#2b0062]">
                        LastCall was created by service industry  professionals for service industry  professionals.
                    </p>

                    <p className="text-lg md:text-xl text-gray-800">
                        It's insane that in 2025 you need multiple tools to promote a night out—social media, email, flyers— it's all
                        too much. Relying on word-of-mouth just doesn't cut it when trying to fill your bar.
                    </p>

                    <p className="text-lg md:text-xl text-gray-800">
                        With a simple, easy-to-use interface and zero heavy lifting on your part, LastCall handles the marketing
                        while you focus on what you do best: serving great drinks.
                    </p>

                    <p className="text-2xl md:text-3xl font-semibold text-[#2b0062]">
                        Our mission? To help you pack the bar and boost your sales.
                    </p>

                    <p className="text-lg md:text-xl text-gray-800">
                        Getting the word out and keeping your crowd engaged shouldn't be complicated. We're here to make it easier
                        for bars to connect with their patrons, drive foot traffic, and turn every night into a win. At LastCall, a
                        win means more money.
                    </p>

                    <p className="text-2xl md:text-3xl font-semibold text-[#2b0062]">That is worth celebrating.</p>
                </div>
                {/* Desktop Footer */}
                <div className="hidden md:block mt-16">
                    <FooterComponents isMobile={false} setIsLoginOpen={setIsLoginOpen} />
                </div>
            </div>
          

                
            <LoginModal open={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
        </div>
    )
}

